import React, {useEffect, useRef, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import TNavMenu from './TNavMenu';
import './NavMenu.scss';
import AppConfig from '../AppConfig';
import {useDispatch, useSelector} from 'react-redux';

import uuid from 'react-uuid';
import SidebarIcon from "../assets/custom-icons/SidebarIcon";
import {BorderlessButton} from "../custom-packages/react-button-package/ButtonPackage";
import {IsPWA} from "../custom-packages/pwa-helper/pwa-helper";
import {GetAuthObject, GetSuperAuthObject} from "../authentication/AuthFunctions";
import * as AuthActions from "../store/actions/authActions";
import {GetHoursDifference, GetLang, GetSecondsDifference, SaveCurrentTime} from "../LocalStorageFunctions";
import {Collapse} from "react-collapse";
import {View} from "../custom-packages/react-native-components-in-react/react-native-components-in-react";
import UpgradeModal from "./admin/Subscription/UpgradeModal";
import {GetDeviceID} from "../AnalyticsFunctions";
import Styles from "../Styles";

export const NavMenu = (props) => {
    const menuPath = '/public/menu';
    const verificationPath = '/verify/code';
    const setupPath = '/admin/setup';
    const setupSubscriptionPath = '/admin/setup/subscription';
    const superAuth = GetSuperAuthObject();
    const preparingPath = '/preparing';
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector(state => state.Auth);
    let subCheckerInterval;
    const isPWA = IsPWA();
    const [navCount, setNavCount] = useState(0);

    const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);

    const [settingsCollapsed, setSettingsCollapsed] = useState(false);

    const [downloadAppSelected, setDownloadAppSelected] = useState(false);
    const [menuSelected, setMenuSelected] = useState(false);
    const [foodSelected, setFoodSelected] = useState(false);
    const [businessSelected, setBusinessSelected] = useState(false);
    const [accountSelected, setAccountSelected] = useState(false);

    const [inMenu, setInMenu] = useState(window.location.pathname.includes(menuPath));
    const [hideNavigation, setHideNavigation] = useState(window.location.pathname.includes(verificationPath));

    const manageSelectedSidebarItem = () => {
        const newDownloadAppSelected = window.location.pathname.includes('/apps');
        const newMenuSelected = window.location.pathname.includes('/menus');
        const newFoodSelected = window.location.pathname.includes('/food');
        const newBusinessSelected = window.location.pathname.includes('/business');
        const newAccountSelected = window.location.pathname.includes('/settings');

        if (newDownloadAppSelected != downloadAppSelected)
            setDownloadAppSelected(newDownloadAppSelected)

        if (newMenuSelected != menuSelected)
            setMenuSelected(newMenuSelected)

        if (newFoodSelected != foodSelected)
            setFoodSelected(newFoodSelected)

        if (newBusinessSelected != businessSelected)
            setBusinessSelected(newBusinessSelected)

        if (newAccountSelected != accountSelected)
            setAccountSelected(newAccountSelected)
    }

    const manageNavigationCount = () => {
        if (isPWA) {
            if (window.location.pathname.includes(preparingPath)) {
                setNavCount(0)
            } else {
                setNavCount(navCount + 1)
            }
        }
    }

    const closeSidebar = () => {
        document.getElementById("sidebarMenu").style.width = "0";
    };

    const openSidebar = () => {
        if (window.innerWidth < 768) {
            document.getElementById("sidebarMenu").style.width = "300px";
        }
    };

    const toggleNavbar = () => {
        if (window.innerWidth < 768) {
            const sidebarWidth = document.getElementById("sidebarMenu").style.width;
            if (sidebarWidth === "300px") {
                closeSidebar();
            } else {
                openSidebar();
            }
        }
    };

    const toggleSettingsCollapsed = () => {
        setSettingsCollapsed(!settingsCollapsed);
    };

    const fetchSub = async () => {
        try {
            const response = await fetch('Subscription/FetchSubscription', {
                method: 'GET',
                headers: {
                    'Authorization': auth.token,
                    'Content-Type': 'application/json',
                },
            });

            const data = await response.json()

            if (data.success) {
                /*const subData = {
                    subscription: data.subscription
                }*/
                const newAuth = GetAuthObject(data);

                dispatch(AuthActions.saveAuth(newAuth))
            }
        } catch (e) {

        }
    }

    const subChecker = async () => {
        console.log('START - Checking subscription')

        const hours = GetHoursDifference('subChecked')

        if (hours >= 2) {
            await fetchSub();

            SaveCurrentTime('subChecked');
        }

        console.log('END - Checking subscription')
    }

    useEffect(() => {
        // search in window.location.pathname for the string /public/menu
        if (window.location.pathname.includes(menuPath)) {
            setInMenu(true)
        } else {
            setInMenu(false)
        }

        // Hides the navigation in certain paths
        setHideNavigation(
            window.location.pathname.includes(verificationPath)
            ||
            window.location.pathname.includes(preparingPath)
        )

        // Selects the correct menu to inform the user where he is
        manageSelectedSidebarItem();

        manageNavigationCount();

        // Go to setup if necessary (Removed)
        //if (!window.location.pathname.includes(verificationPath) && auth.token && !auth.businessID && auth.role == 'Bow')
        //navigate('/admin/setup', {replace: true});

        if (isPWA) {
            if (window.location.pathname === '/') {
                if (auth && auth.token && auth.sub) {
                    navigate('/admin/menus', {replace: true});
                } else {
                    navigate('/auth?type=BUSINESS', {replace: true});
                }
            }
        } else {
            if (window.location.pathname === '/' || window.location.pathname === '/auth') {
                if (auth && auth.token) {
                    const superAuth = GetSuperAuthObject()
                    if (superAuth && superAuth.role == 'Adm') {
                        navigate('/super-admin/tokens', {replace: true});
                    } else if (auth.sub) {
                        navigate('/admin/menus', {replace: true});
                    } else {
                        navigate('/admin/setup/subscription', {replace: true});
                    }
                }
            }
        }

        AppConfig.lang = GetLang()

        const subLogic = async () => {

            await subChecker();

            const localAuth = GetAuthObject()

            if(localAuth.token && !localAuth.sub) {
                subCheckerInterval = setTimeout(() => {
                    fetchSub();
                }, 1500)
            }
        }

        subLogic()

        return () => {
            if(subCheckerInterval)
                clearInterval(subCheckerInterval)
        }
    }, [window.location.pathname])

    useEffect(() => {
        const token = localStorage.getItem("token");

        const f = () => {
            // Store the current route into a constant
            const route = window.location.pathname + window.location.search;
            const uri = '/preparing?returnUrl=' + route;

            navigate(uri, {replace: true});
            const deviceID = localStorage.getItem('deviceID');

            if (!deviceID)
                localStorage.setItem('deviceID', uuid())
        }

        if (token && !auth.token && !window.location.pathname.includes('/public/menu'))
            f()

        GetDeviceID();
    }, []);

    if (
        window.location.pathname.includes('/public/menu')
        ||
        window.location.pathname === '/'
        ||
        window.location.pathname === '/enUS'
    )
        return null;

    let navOptions = auth.token ?
        <div className="menu-container">
            {auth.role == 'Adm' || auth.role == 'Bow' ?
                <div
                    className="menu-container"
                >
                    {superAuth.role == 'Adm' ?
                        <BorderlessButton
                            textStyle={{color: 'white'}}
                            alignText={'left'}
                            className={`${downloadAppSelected ? 'selected' : ''}`}
                            onPress={toggleNavbar}
                            to={{
                                uri: "/super-admin/tokens",
                                config: {replace: false}
                            }}
                            text={TNavMenu[AppConfig.lang].TOKEN_MASTER}
                        />
                        :
                        null
                    }
                    {false && !auth.sub ?
                        <BorderlessButton
                            textStyle={{color: 'white'}}
                            alignText={'left'}
                            className={`${downloadAppSelected ? 'selected' : ''}`}
                            onPress={toggleNavbar}
                            to={{
                                uri: "/admin/setup/subscription",
                                config: {replace: false}
                            }}
                            text={TNavMenu[AppConfig.lang].SEE_PLANS}
                        />
                        :
                        null
                    }
                    {auth.sub && (
                        auth.sub.code === AppConfig.SUB_BASIC
                    ) ?
                        <BorderlessButton
                            textStyle={{color: 'white'}}
                            alignText={'left'}
                            className={`${downloadAppSelected ? 'selected' : ''}`}
                            onPress={() => {
                                toggleNavbar()
                                setIsUpgradeModalOpen(true)
                            }}
                            text={TNavMenu[AppConfig.lang].UPGRADE_PLAN}
                        />
                        :
                        null
                    }
                    {auth.sub && (
                        auth.sub.code === AppConfig.SUB_STANDARD
                        ||
                        auth.sub.code === AppConfig.SUB_PREMIUM
                    ) ?
                        <BorderlessButton
                            textStyle={{color: 'white'}}
                            alignText={'left'}
                            className={`${downloadAppSelected ? 'selected' : ''}`}
                            onPress={toggleNavbar}
                            to={{
                                uri: "/admin/apps",
                                config: {replace: false}
                            }}
                            text={TNavMenu[AppConfig.lang].DOWNLOAD_APPS}
                        />
                        :
                        null
                    }
                    {auth.sub ?
                        <BorderlessButton
                            textStyle={{color: 'white'}}
                            alignText={'left'}
                            className={`${menuSelected ? 'selected' : ''}`}
                            onPress={toggleNavbar}
                            to={{
                                uri: "/admin/menus",
                                config: {replace: false}
                            }}
                            text={TNavMenu[AppConfig.lang].MENUS}
                        />
                        :
                        null
                    }
                    {auth.sub ?
                        <BorderlessButton
                            textStyle={{color: 'white'}}
                            alignText={'left'}
                            className={`${foodSelected ? 'selected' : ''}`}
                            onPress={toggleNavbar}
                            to={{
                                uri: "/admin/food",
                                config: {replace: false}
                            }}
                            text={TNavMenu[AppConfig.lang].FOOD}
                        />
                        :
                        null
                    }
                    {auth.sub && (
                        auth.sub.code === AppConfig.SUB_STANDARD
                        ||
                        auth.sub.code === AppConfig.SUB_PREMIUM
                    ) ?
                        <BorderlessButton
                            textStyle={{color: 'white'}}
                            alignText={'left'}
                            className={`${businessSelected ? 'selected' : ''}`}
                            onPress={toggleNavbar}
                            to={{
                                uri: "/admin/business",
                                config: {replace: false}
                            }}
                            text={TNavMenu[AppConfig.lang].MY_BUSINESS}
                        />
                        :
                        null
                    }
                </div>
                :
                null
            }
            <div style={{position: 'relative'}}>
                <BorderlessButton
                    textStyle={{color: 'white'}}
                    alignText={'left'}
                    className={`${accountSelected ? 'selected' : ''}`}
                    onPress={toggleSettingsCollapsed}
                    text={TNavMenu[AppConfig.lang].ACCOUNT}
                />
                <div style={{
                    position: 'absolute',
                    zIndex: 10,
                    width: '100%',
                    minWidth: '150px'
                }}>
                    <Collapse isOpened={settingsCollapsed}>
                        <div
                            style={{
                                backgroundColor: '#d03201',
                                textAlign: 'center'
                            }}
                        >
                            <Link
                                onClick={() => {
                                    toggleNavbar();
                                    toggleSettingsCollapsed();
                                }}
                                className="dropdown-item nav-link"
                                to="/admin/settings"
                                style={{color: 'white'}}
                            >
                                {TNavMenu[AppConfig.lang].SETTINGS}
                            </Link>
                            <Link
                                onClick={() => {
                                    toggleNavbar();
                                    toggleSettingsCollapsed();
                                }}
                                className="dropdown-item nav-link"
                                to="/logout"
                                style={{color: 'white'}}
                            >
                                {TNavMenu[AppConfig.lang].LOGOUT}
                            </Link>
                        </div>
                    </Collapse>
                </div>
            </div>
        </div>
        :
        <div>
            <BorderlessButton
                textStyle={{color: 'white'}}
                alignText={'left'}
                onPress={toggleNavbar}
                to={"/auth?type=BUSINESS"}
                text={TNavMenu[AppConfig.lang].SIGN_IN}
            />
        </div>

    return (
        <header>
            <div className="navbar navbar-expand-sm navbar-toggleable-sm ng-white mb-3">
                <div className={'container'}>
                    <div
                        id="sidebarMenu"
                        className="sidebar"
                    >
                        <a
                            className="closebtn"
                            onClick={closeSidebar}
                            style={{color: 'white'}}
                        >
                            &times;
                        </a>

                        {/* Mobile View */}
                        {!inMenu && !hideNavigation && (
                            <div>
                                {navOptions}
                            </div>
                        )}
                    </div>
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        {inMenu || hideNavigation ?
                            null
                            :
                            <span
                                className={'d-md-none'}
                                onClick={toggleNavbar}
                                style={{
                                    marginRight: 10,
                                    padding: '2px 8px',
                                    border: '1px solid white',
                                    borderRadius: 4
                                }}
                            >
                               <SidebarIcon
                                   fill={'white'}
                                   width={20}
                                   height={20}
                               />
                            </span>
                        }
                        <Link className="special-title" style={{fontSize: '1.6rem', padding: 0}} to={
                            auth && auth.sub ? "/admin/menus" : "/"
                        }>Tastee</Link>
                    </div>
                    {inMenu || hideNavigation ?
                        null
                        :
                        <div className={'desktop-menu'}>
                            {navOptions}
                        </div>
                    }
                </div>
            </div>
            <UpgradeModal
                visible={isUpgradeModalOpen}
                onRequestClose={() => {
                    setIsUpgradeModalOpen(false)
                }}
                plan={AppConfig.SUB_STANDARD}
            />
        </header>
    );
}